import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopHypermarkets = dynamic(() => import('../../components/grocery/hypermarkets/DesktopHypermarkets'), {
  loading: () => <Loading />,

});
const MobileHypermarkets = dynamic(() => import('../../components/grocery/hypermarkets/MobileHypermarkets'), {
  loading: () => <Loading />,

});


const fmcg = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Hypermarket Billing Software in India - Get a Free Demo</title>
        <meta name="description" content="QueueBuster POS offers powerful hypermarket billing software with low stock alerts, inventory management, and a customer loyalty program. Get a Free Demo"
        />
        <link rel="canonical" href="https://queuebuster.co/grocery/hypermarkets-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/grocery/hypermarkets-pos-billing-software" hrefLang="en-us" />
        <meta property="og:title" content="Hypermarket Billing Software in India - Get a Free Demo" />
        <meta property="og:description" content="QueueBuster POS offers powerful hypermarket billing software with low stock alerts, inventory management, and a customer loyalty program. Get a Free Demo" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/hypermarkets.jpg"
        />
        <meta property="og:url" content="https://queuebuster.co/grocery/hypermarkets-pos-billing-software" />

      </Head>
         <SchemaTags page="hypermarkets-pos-billing-software" />
      {
        mobileView ? <MobileHypermarkets /> : <DesktopHypermarkets />
      }
    </>
  )
}

export default fmcg